import {BridgeComponent} from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "add-to-calendar"

  static get shouldLoad() {
    return true
  }
  static values = {
    eventPayload: Object,
    markAddedUrl: String,
  }

  add() {
    this.send("add", this.eventPayloadValue, () => {
      fetch(this.markAddedUrlValue, {
        method: "PUT",
        headers: {
          "X-CSRF-Token": this.#csrfToken,
          "Accept": "text/vnd.turbo-stream.html",
        },
      }).then((response) => {
        if (response.ok) {
          response.text().then((html) => Turbo.renderStreamMessage(html))
        }
      })
    })
  }

  get #csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content
  }
}
